import TaxonomyTerm from "../../types/TaxonomyTerm";
import { TaxonomyAction, TaxonomyState } from "./TaxonomyState";

export const DISPATCH = 'WIS/taxonomy/gender/DISPATCHED';
export const FULFILL = 'WIS/taxonomy/gender/FULFILLED';
export const REJECT = 'WIS/taxonomy/gender/REJECTED';

export type GenderActionTypes = 
  'WIS/taxonomy/gender/DISPATCHED'
  | 'WIS/taxonomy/gender/FULFILLED'
  | 'WIS/taxonomy/gender/REJECTED';

export const dispatch = () => ({ type: DISPATCH });
export const fulfill = (payload: TaxonomyTerm[]) => ({ type: FULFILL, payload });
export const reject = (error: string) => ({ type: REJECT, error });

const initialState: TaxonomyState = {
  terms: [],
  isFetching: false,
  isFetched: false,
  error: null,
};

export type TaxonomyGenderAction = TaxonomyAction<GenderActionTypes>;

export default function reducer(state = initialState, action: TaxonomyGenderAction) {
  switch (action.type) {
    case DISPATCH:
      return {
        ...state,
        isFetching: true,
      };

    case FULFILL:
      return {
        ...state,
        terms: action.payload,
        isFetching: false,
        isFetched: true,
        error: null,
      };

    case REJECT:
      return {
        ...state,
        error: action.error,
        isFetching: false,
      };

    default:
      return state;
  }
}
